import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TransactionResolver } from '@ruby/core/resolvers/transaction.resolver';
import { EBillLocationContainer } from '@ruby/modules/ebill/submodules/ebill-location/containers/ebill-location.container';

const routes: Routes = [{
  path: '',
  component: EBillLocationContainer,
  pathMatch: 'full',
  resolve: { transaction: TransactionResolver },
  runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  data: { skipTransaction: true }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EBillLocationRoutingModule {}
